import MuiCheckbox, { CheckboxProps as MuiCheckboxProps, CheckboxPropsColorOverrides } from '@mui/material/Checkbox';
import { OverridableStringUnion } from '@mui/types';
import { forwardRef } from 'react';

declare module '@mui/material/Checkbox' {
  export interface CheckboxPropsColorOverrides {
    internal: true;
  }
}

export interface CheckboxProps extends MuiCheckboxProps {
  color?: OverridableStringUnion<
    'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | 'internal',
    CheckboxPropsColorOverrides
  >;
}

const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
  return <MuiCheckbox ref={ref} {...props} />;
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
